import { useQuery } from '@tanstack/react-query';
import { useDispatch, useSelector } from 'react-redux';
import { useMemo, useEffect } from 'react';

import { userAPI } from '../api/userAPI';
import { userInfoAdapter } from '../libs/userAddapter';
import { Gender, setUser } from '../../../store/slices/userSlice';
import { userInfo } from '../../../store/selectors/user';
import { setMindboxDeviceUUID } from '../../../lib/mindbox';
import { saveLoyaltyUserId } from '../../../modules/loyalty/libs/qrStorage';

export const useGetUserProfile = () => {
  const dispatch = useDispatch();
  const user = useSelector(userInfo);
  const token = localStorage.getItem('token');

  const initData = useMemo(() => ({ user: userInfoAdapter() }), []);

  const queryResult = useQuery({
    queryKey: ['user-profile', token],
    queryFn: async () => await userAPI.getProfile(),
    select: data => ({
      user: userInfoAdapter(data.data),
    }),
  });

  const { data = initData, isLoading } = queryResult;

  // deviceUUID отдаём в lib/mindbox до всех проверок ниже: он про устройство, а
  // не про профиль, и нужен, даже если пользователь только что разлогинился, —
  // иначе `/mb/user-info` и оформление заказа уйдут без него.
  const deviceUUID = data.user?.deviceUUID;

  useEffect(() => {
    setMindboxDeviceUUID(deviceUUID);
  }, [deviceUUID]);

  useEffect(() => {
    if (!isLoading && data?.user) {
      if (data.user.phone_number.length > 15) {
        localStorage.removeItem('token');
        dispatch(setUser({ ...user, isAuth: false }));
        return;
      }

      const loggedOut = localStorage.getItem('loggedOut') === 'true';

      if (data.user._id && !loggedOut) {
        // id нужен статичному QR офлайн, когда профиль без сети не
        // загрузится — см. modules/loyalty/libs/qrStorage.
        saveLoyaltyUserId(data.user._id);
        dispatch(
          setUser({
            _id: data.user._id,
            name: data.user.full_name ? data.user.full_name : 'EVOS',
            phone: data.user.phone_number ? data.user.phone_number : '',
            email: data.user.email,
            dob: data.user.date_of_birth,
            gender: data.user.gender as Gender,
            profile_picture: data.user.profile_picture,
            isAuth: true,
            tg_username: '',
            language: localStorage.getItem('language') || 'uz',
            lastOrderDate: data.user.lastOrderDate,
          })
        );
      }
    }
  }, [isLoading, data.user, dispatch, user]);

  return {
    ...data,
    isLoading,
  };
};
